const SudokuIFrame = () => {
    const sudokuUrl = window.location.hostname === "localhost"
        ? "https://localhost:7094/"
        : "/sudoku/";

    return(
        <div style={{ width: "100%", height: "600px", border: "none" }}>
            <iframe
                src={sudokuUrl}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="Sudoku"
            />
        </div>
    )
}

export default SudokuIFrame;